import Imei from '@/api/master/Imei'
import Functions from '@/functions'

export default {
  namespaced: true,
  state: {
    total: 0,
    data: []
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data.data
      state.total = data.total
    }
  },
  actions: {
    datatable({ commit }, params) {
      return Imei.datatable(params)
        .then((res) => {
          commit('SET_DATA', res.data.message)
        })
        .catch((error) => {
          Functions.httpErrorHandler(error)
          return { status: false, message: null }
        })
    },
    template({}) {
      return Imei.template()
        .then((res) => {
          return { status: true, message: res.data }
        })
        .catch((error) => {
          Functions.httpErrorHandler(error)
          return { status: false, message: null }
        })
    },
    import({}, data) {
      return Imei.import(data)
        .then((res) => {
          return res.data
        })
        .catch((error) => {
          Functions.httpErrorHandler(error)
          return { status: false, message: null }
        })
    },
    delete({}, id) {
      return Imei.delete(id)
        .then((res) => {
          return res.data
        })
        .catch((error) => {
          Functions.httpErrorHandler(error)
          return { status: false, message: null }
        })
    },
    approve({}, id) {
      return Imei.approve(id)
        .then((res) => {
          return res.data
        })
        .catch((error) => {
          Functions.httpErrorHandler(error)
          return { status: false, message: null }
        })
    },
    exportResponse({}, data) {
      return Imei.exportResponse(data)
        .then((res) => {
          return { status: true, message: res.data }
        })
        .catch((error) => {
          Functions.httpErrorHandler(error)
          return { status: false, message: null }
        })
    },
    detail_imei({}, id) {
      return Imei.detail_imei(id)
        .then((res) => {
          return { status: true, message: res.data }
        })
        .catch((error) => {
          Functions.httpErrorHandler(error)
          return { status: false, message: null }
        })
    },

    blacklist({}, form_data) {
      return Imei.blacklist(form_data)
        .then((res) => {
          return { status: true, message: res.data }
        })
        .catch((error) => {
          Functions.httpErrorHandler(error)
          return { status: false, message: null }
        })
    }
  },
  getters: {}
}
